<div class="container" >
    <div class="row d-flex justify-content-center">
        <div class="col-md-4 ">
            <!--FORM1 Start-->
            <div class="card-body">
               
                <form [formGroup]="itiForm" (ngSubmit)="onItiSubmit()">
                    <div class="form-row">
                      <div class="form-group col-12">
                          <label>MIS Code <span class="clr_red"> * </span></label>
                          <input type="text" formControlName="iticode" [(ngModel)]="reciveiticode" class="form-control" readonly
                              />

                         
                      </div>
                       

                    </div>
                    <hr>
                    <div class="form-row">
                        <div class="form-group col-12">
                            <div class="text-center">
                                <button class="btn btn-primary mr-1">Click to select candidates </button>
                            </div>
                        </div>
                    </div>
                </form>
  
               
              </div>
              </div>
            </div>
        </div>
